// src/utils/excelUtils.js

// Helper function to format date
export const formatDate = (date) => {
  if (!date) return "";
  try {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  } catch {
    return "";
  }
};

// Generate file name with Project ID, Project Name, Form Name, and Date Range
export const generateExcelFileName = (formName, startDate, endDate) => {
  const sanitize = (val) =>
    (val || "")
      .replace(/^["']|["']$/g, "") // Strip accidental JSON quotes
      .trim()
      .replace(/[\\/:*?"<>|\s]+/g, "_"); // Replace illegal filename characters & whitespace

  const rawProjectId = typeof window !== "undefined" ? localStorage.getItem("selectedProject") : "";
  const rawProjectName = typeof window !== "undefined" ? localStorage.getItem("selectedProjectName") : "";

  const projectId = sanitize(rawProjectId);
  const projectName = sanitize(rawProjectName);

  const prefix = [projectId, projectName].filter(Boolean).join("_");
  const formStr = sanitize(formName);
  const startStr = formatDate(startDate || new Date());
  const endStr = formatDate(endDate || new Date());

  return `${prefix ? `${prefix}_` : ""}${formStr}_${startStr}_to_${endStr}.xlsx`;
};